<template>
  <section :id="module.id" class="faqs" :style="[faqsElStyles]">
    <GlobalUIMedia
      v-if="module.config.general.showMedia"
      :media="module.config.general.media"
      :lazy="lazy"
    />
    <div class="faqs-container" :style="modulePadding">
      <Faq
        v-for="faq in module.modules"
        :key="faq.id"
        :id="faq.id"
        :module="faq"
        :parentModule="module"
        :forceOpen="forceAllOpen"
      />
    </div>
  </section>
</template>

<script>
import faqsModule from "./faqsDefaultModuleProp.js";
import { globalComputed, globalMethods } from "../../GlobalUI/mixins/global.js";
import Faq from "../Faq/Faq.vue";
import GlobalUIMedia from "../../GlobalUI/GlobalUIMedia.vue";

export default {
  name: "Faqs",
  mixins: [globalComputed, globalMethods],
  components: {
    Faq,
    GlobalUIMedia,
  },
  props: {
    module: {
      type: Object,
      default() {
        return faqsModule;
      },
    },
    // for the purpose of opening all items in editor
    forceAllOpen: {
      type: Boolean,
      default() {
        return false;
      },
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    faqsElStyles() {
      const { moduleBackgroundColor } = this.module.config.general;

      const styles = {
        backgroundColor: moduleBackgroundColor.value,
      };

      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
@include reset;

.faqs {
  container-type: inline-size;
  contain: layout;
  display: flex;
  justify-content: center;
}

.faqs-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  gap: 12px;

  width: 100%;
  max-width: 1600px;
  padding-inline: var(--cr-module-padding-large);

  @include laptop {
    padding-inline: calc(var(--cr-module-padding-large) / 2);
  }

  @include mobile {
    padding-inline: 25px;
  }
}
</style>
